<template>
    <form-view class="weibo-service-form-view" @submitsuccess="back">
        <template slot="field">
            <veui-field label="应用名称："
                name="appId"
                field="appId"
                :disabled="isEdit"
                :readonly="!!store.createForFixedAppId"
                rules="required">
                <search-select
                    :options="store.appDatasource"
                    v-model="store.formData.appId"
                    placeholder="请选择"/>
                    <veui-button v-if="isCreate" @click="goToCreateApp" ui="link">新建应用</veui-button>
            </veui-field>
            <veui-field label="服务名称："
                name="name"
                field="name"
                :disabled="!isEditDraft && !isCreate"
                :rules="validator('required|name|maxLength:20')"
                tip="最多可输入20个字符">
                <veui-input
                    v-model="store.formData.name"
                    placeholder="数字、字母、汉字"/>
            </veui-field>
            <veui-field label="微博ID："
                name="weiboId"
                field="weiboId"
                :disabled="!isEditDraft && !isCreate"
                :rules="validator('required|number')">
                <veui-input
                    v-model="store.formData.weiboId"
                    placeholder="请输入数字"/>
            </veui-field>
            <veui-field label="微博名称："
                name="weiboName"
                field="weiboName"
                :disabled="!isEditDraft && !isCreate"
                rules="required">
                <veui-input
                    v-model="store.formData.weiboName"/>
            </veui-field>
        </template>
        <template slot="operation">
            <template v-if="isCreate || isEditDraft">
                <veui-button ui="primary" type="submit"
                    @click="store.formData.submitType='publish'">提交发布</veui-button>
                <veui-button class="primary-border-btn"
                    type="submit"
                    @click="store.formData.submitType='save'">保存为草稿</veui-button>
            </template>
            <veui-button @click="back">{{ cancelText }}</veui-button>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Input, Span, Select, RadioGroup, Textarea} from 'veui';
import SearchSelect from '@/common/components/SearchSelect';
import serviceMixin from '@/common/mixins/service';
import {get} from 'lodash';

export default createView(FormView, FormModel, {
    name: 'WeiboServiceFormView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button,
        'veui-select': Select,
        'veui-radio-group': RadioGroup,
        'veui-textarea': Textarea,
        SearchSelect
    },
    mixins: [serviceMixin],
    computed: {
        weiboId() {
            return get(this.store.serviceDetail, 'serviceData.weiboId');
        }
    }
});
</script>
